<template>
  <div>
    <div class="supplement-step3-content">
      <!-- B2C 时，显示筛选项 -->
      <div v-if="serviceType === '2'" class="entity-type-list">
        <div
          v-for="(item, index) in entityTypeList"
          :key="index"
          class="entity-type-item"
          :class="[entityType === item.value ? 'active' : '']"
          @click="handleServiceType(item.value)">
          {{$t(item.label)}}
        </div>
      </div>
    </div>
    <template v-if="entityType === '1'">
      <individual-info
        :quickRegistration="quickRegistration"
        :merchantNo="merchantNo"
        :serviceType="serviceType"
        :supplementInfo="supplementInfo"
        :errorMessage="auditErrorMessage1"
        @finish="onSubmit">
      </individual-info>
    </template>
    <template v-if="entityType === '0'">
      <business-info
        :quickRegistration="quickRegistration"
        :merchantNo="merchantNo"
        :serviceType="serviceType"
        :supplementInfo="supplementInfo"
        :errorMessage="auditErrorMessage2"
        @finish="onSubmit">
      </business-info>
    </template>
  </div>
</template>

<script>
import BusinessInfo from '@/views/account/information/supplement/business/index.vue';
import IndividualInfo from '@/views/account/information/supplement/individual/index.vue';

export default {
  components: {
    BusinessInfo,
    IndividualInfo,
  },
  props: {
    quickRegistration: {
      type: Boolean,
      default: false,
    },
    merchantNo: {
      type: String,
      default: '',
    },
    serviceType: {
      type: String,
      default: '', // 1: 收单  0: B2B  2: B2C
    },
    supplementInfo: {
      type: Object,
      default: () => ({}),
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      entityTypeList: [{
        label: 'message.user.personalAccount',
        value: '1',
      }, {
        label: 'message.user.corporateAccount',
        value: '0',
      }],
      entityType: '0',
      auditErrorMessage1: '',
      auditErrorMessage2: '',
    };
  },
  created() {
    this.entityType = this.serviceType === '2' ? '1' : '0';
    if (this.supplementInfo) { // 通过初始化数据配置
      if (`${this.supplementInfo.type}` === '2') { // 个人账户
        this.entityType = '1';
        this.auditErrorMessage1 = this.errorMessage;
      } else {
        this.entityType = '0';
        this.auditErrorMessage2 = this.errorMessage;
      }
    }
  },
  methods: {
    handleServiceType(value) {
      this.entityType = value;
    },
    onSubmit() {
      this.$emit('finish');
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/element-variables.scss';
.step3-content {
  margin-top: 50px;
}
.supplement-step3-content {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 50px;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 600;
  color: $color-text-primary;
  line-height: 22px;

  .entity-type-list {
    display: flex;
    align-items: center;

    .entity-type-item {
      width: 120px;
      height: 44px;
      background: $color-default;
      border-radius: 22px;
      font-size: 14px;
      font-weight: 600;
      color: $color-text-default-button;
      line-height: 44px;
      text-align: center;
      margin-right: 30px;
      cursor: pointer;

      &.active {
        width: 120px;
        height: 44px;
        background: $color-text-default-button;
        border-radius: 22px;
        color: white;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
